"use client";

import Link from "next/link";
import { useAdmin } from "./admin-context";
import { GearSix } from "@phosphor-icons/react";

/**
 * Thin teal strip at the very top of the page indicating admin mode.
 * Only renders when the user is an admin. Sits above the nav bar.
 * z-[400] to stay above the nav (z-[200]) and modals (z-[300]).
 */
export function AdminBar() {
  const isAdmin = useAdmin();
  if (!isAdmin) return null;

  return (
    <div className="fixed inset-x-0 top-0 z-[400] flex h-7 items-center justify-between bg-wildroost-teal px-4 text-xs font-medium text-white">
      <div className="flex items-center gap-2">
        <GearSix size={14} weight="fill" aria-hidden="true" />
        <span>Admin mode</span>
      </div>
      <Link
        href="/admin"
        className="rounded bg-white/20 px-2 py-0.5 text-xs font-semibold text-white transition-colors hover:bg-white/30"
      >
        Admin Dashboard
      </Link>
    </div>
  );
}
